<template>
    <div class="site-panel v-flex" v-if="site">
        <c-inc-maintenance-list
            :site = "site"
            :readonly = "readonly"
        />
    </div>
</template>

<script>

import CIncMaintenanceList from "@/modules/inc/maintenance/CIncMaintenanceList";

export default {
    name: "TSiteMaintenance",

    components: {
        CIncMaintenanceList,
    },

    props: {
        site: {

        },

        readonly: {
            required: true,
            type    : Boolean
        },
    },

    methods: {
    }
}
</script>

<style scoped>

</style>